.control-label {
  margin: 0px;
  display: inline-block;
  vertical-align: middle;
  min-height: 28px;
}

.pg-panel-properties-message {
  margin-top: 50px !important;
}
.show_progress {
  cursor: progress;
}
.user-language {
  margin-top: 10px;
}
.user-language label{
  float:left;
  font-weight: normal !important;
}
.user-language div{
  float:left;
}

.Resizer {
  background: $color-gray-lighter;
  z-index: 1;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -moz-background-clip: padding;
  -webkit-background-clip: padding;
  background-clip: padding-box;
}

.Resizer.horizontal {
  width: 100%;
  height: $panel-border-width;
  cursor: ew-resize;
  background-color: $panel-border-color;
}


.Resizer.vertical {
  width: $panel-border-width;
  cursor: ew-resize;
  background-color: $panel-border-color;
}

.Resizer.disabled {
  cursor: not-allowed;
}

.Resizer.disabled:hover {
  border-color: transparent;
}

.pg-icon {
  width: $navbar-height*3;
  height: 100%;
  /*
   * Using the SVG postgresql logo, modified to set the background color as #FFF
   * https://wiki.postgresql.org/images/9/90/PostgreSQL_logo.1color_blue.svg
   * background: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 42 42' style='enable-background:new 0 0 42 42;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bstroke:%23000000;stroke-width:3.3022;%7D .st1%7Bfill:%23336791;%7D .st2%7Bfill:none;stroke:%23FFFFFF;stroke-width:1.1007;stroke-linecap:round;stroke-linejoin:round;%7D .st3%7Bfill:none;stroke:%23FFFFFF;stroke-width:1.1007;stroke-linecap:round;stroke-linejoin:bevel;%7D .st4%7Bfill:%23FFFFFF;stroke:%23FFFFFF;stroke-width:0.3669;%7D .st5%7Bfill:%23FFFFFF;stroke:%23FFFFFF;stroke-width:0.1835;%7D .st6%7Bfill:none;stroke:%23FFFFFF;stroke-width:0.2649;stroke-linecap:round;stroke-linejoin:round;%7D%0A%3C/style%3E%3Cg id='orginal'%3E%3C/g%3E%3Cg id='Layer_x0020_3'%3E%3Cpath class='st0' d='M31.3,30c0.3-2.1,0.2-2.4,1.7-2.1l0.4,0c1.2,0.1,2.8-0.2,3.7-0.6c2-0.9,3.1-2.4,1.2-2 c-4.4,0.9-4.7-0.6-4.7-0.6c4.7-7,6.7-15.8,5-18c-4.6-5.9-12.6-3.1-12.7-3l0,0c-0.9-0.2-1.9-0.3-3-0.3c-2,0-3.5,0.5-4.7,1.4 c0,0-14.3-5.9-13.6,7.4c0.1,2.8,4,21.3,8.7,15.7c1.7-2,3.3-3.8,3.3-3.8c0.8,0.5,1.8,0.8,2.8,0.7l0.1-0.1c0,0.3,0,0.5,0,0.8 c-1.2,1.3-0.8,1.6-3.2,2.1c-2.4,0.5-1,1.4-0.1,1.6c1.1,0.3,3.7,0.7,5.5-1.8l-0.1,0.3c0.5,0.4,0.4,2.7,0.5,4.4 c0.1,1.7,0.2,3.2,0.5,4.1c0.3,0.9,0.7,3.3,3.9,2.6C29.1,38.3,31.1,37.5,31.3,30'/%3E%3Cpath class='st1' d='M38.3,25.3c-4.4,0.9-4.7-0.6-4.7-0.6c4.7-7,6.7-15.8,5-18c-4.6-5.9-12.6-3.1-12.7-3l0,0 c-0.9-0.2-1.9-0.3-3-0.3c-2,0-3.5,0.5-4.7,1.4c0,0-14.3-5.9-13.6,7.4c0.1,2.8,4,21.3,8.7,15.7c1.7-2,3.3-3.8,3.3-3.8 c0.8,0.5,1.8,0.8,2.8,0.7l0.1-0.1c0,0.3,0,0.5,0,0.8c-1.2,1.3-0.8,1.6-3.2,2.1c-2.4,0.5-1,1.4-0.1,1.6c1.1,0.3,3.7,0.7,5.5-1.8 l-0.1,0.3c0.5,0.4,0.8,2.4,0.7,4.3c-0.1,1.9-0.1,3.2,0.3,4.2c0.4,1,0.7,3.3,3.9,2.6c2.6-0.6,4-2,4.2-4.5c0.1-1.7,0.4-1.5,0.5-3 l0.2-0.7c0.3-2.3,0-3.1,1.7-2.8l0.4,0c1.2,0.1,2.8-0.2,3.7-0.6C39,26.4,40.2,24.9,38.3,25.3L38.3,25.3z'/%3E%3Cpath class='st2' d='M21.8,26.6c-0.1,4.4,0,8.8,0.5,9.8c0.4,1.1,1.3,3.2,4.5,2.5c2.6-0.6,3.6-1.7,4-4.1c0.3-1.8,0.9-6.7,1-7.7'/%3E%3Cpath class='st2' d='M18,4.7c0,0-14.3-5.8-13.6,7.4c0.1,2.8,4,21.3,8.7,15.7c1.7-2,3.2-3.7,3.2-3.7'/%3E%3Cpath class='st2' d='M25.7,3.6c-0.5,0.2,7.9-3.1,12.7,3c1.7,2.2-0.3,11-5,18'/%3E%3Cpath class='st3' d='M33.5,24.6c0,0,0.3,1.5,4.7,0.6c1.9-0.4,0.8,1.1-1.2,2c-1.6,0.8-5.3,0.9-5.3-0.1 C31.6,24.5,33.6,25.3,33.5,24.6c-0.1-0.6-1.1-1.2-1.7-2.7c-0.5-1.3-7.3-11.2,1.9-9.7c0.3-0.1-2.4-8.7-11-8.9 c-8.6-0.1-8.3,10.6-8.3,10.6'/%3E%3Cpath class='st2' d='M19.4,25.6c-1.2,1.3-0.8,1.6-3.2,2.1c-2.4,0.5-1,1.4-0.1,1.6c1.1,0.3,3.7,0.7,5.5-1.8c0.5-0.8,0-2-0.7-2.3 C20.5,25.1,20,24.9,19.4,25.6L19.4,25.6z'/%3E%3Cpath class='st2' d='M19.3,25.5c-0.1-0.8,0.3-1.7,0.7-2.8c0.6-1.6,2-3.3,0.9-8.5c-0.8-3.9-6.5-0.8-6.5-0.3c0,0.5,0.3,2.7-0.1,5.2 c-0.5,3.3,2.1,6,5,5.7'/%3E%3Cpath class='st4' d='M18,13.8c0,0.2,0.3,0.7,0.8,0.7c0.5,0.1,0.9-0.3,0.9-0.5c0-0.2-0.3-0.4-0.8-0.4C18.4,13.6,18,13.7,18,13.8 L18,13.8z'/%3E%3Cpath class='st5' d='M32,13.5c0,0.2-0.3,0.7-0.8,0.7c-0.5,0.1-0.9-0.3-0.9-0.5c0-0.2,0.3-0.4,0.8-0.4C31.6,13.2,32,13.3,32,13.5 L32,13.5z'/%3E%3Cpath class='st2' d='M33.7,12.2c0.1,1.4-0.3,2.4-0.4,3.9c-0.1,2.2,1,4.7-0.6,7.2'/%3E%3Cpath class='st6' d='M2.7,6.6'/%3E%3C/g%3E%3C/svg%3E%0A")  0 0 no-repeat;
   */
  background: url(data:image/svg+xml;base64,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)  0 0 no-repeat;
  background-position-y: center;
}

.dashboard-pg-doc {
  display: inline-block;
  width: 50px;
  height: 50px;
  /*
   * Using the SVG postgresql logo, modified to set the background color as
   * black
   * https://wiki.postgresql.org/images/a/a4/PostgreSQL_logo.3colors.svg
   */
  background: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 42 42' style='enable-background:new 0 0 42 42;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bstroke:%23000000;stroke-width:3.3022;%7D .st1%7Bfill:%23336791;%7D .st2%7Bfill:none;stroke:%23FFFFFF;stroke-width:1.1007;stroke-linecap:round;stroke-linejoin:round;%7D .st3%7Bfill:none;stroke:%23FFFFFF;stroke-width:1.1007;stroke-linecap:round;stroke-linejoin:bevel;%7D .st4%7Bfill:%23FFFFFF;stroke:%23FFFFFF;stroke-width:0.3669;%7D .st5%7Bfill:%23FFFFFF;stroke:%23FFFFFF;stroke-width:0.1835;%7D .st6%7Bfill:none;stroke:%23FFFFFF;stroke-width:0.2649;stroke-linecap:round;stroke-linejoin:round;%7D%0A%3C/style%3E%3Cg id='orginal'%3E%3C/g%3E%3Cg id='Layer_x0020_3'%3E%3Cpath class='st0' d='M31.3,30c0.3-2.1,0.2-2.4,1.7-2.1l0.4,0c1.2,0.1,2.8-0.2,3.7-0.6c2-0.9,3.1-2.4,1.2-2 c-4.4,0.9-4.7-0.6-4.7-0.6c4.7-7,6.7-15.8,5-18c-4.6-5.9-12.6-3.1-12.7-3l0,0c-0.9-0.2-1.9-0.3-3-0.3c-2,0-3.5,0.5-4.7,1.4 c0,0-14.3-5.9-13.6,7.4c0.1,2.8,4,21.3,8.7,15.7c1.7-2,3.3-3.8,3.3-3.8c0.8,0.5,1.8,0.8,2.8,0.7l0.1-0.1c0,0.3,0,0.5,0,0.8 c-1.2,1.3-0.8,1.6-3.2,2.1c-2.4,0.5-1,1.4-0.1,1.6c1.1,0.3,3.7,0.7,5.5-1.8l-0.1,0.3c0.5,0.4,0.4,2.7,0.5,4.4 c0.1,1.7,0.2,3.2,0.5,4.1c0.3,0.9,0.7,3.3,3.9,2.6C29.1,38.3,31.1,37.5,31.3,30'/%3E%3Cpath class='st1' d='M38.3,25.3c-4.4,0.9-4.7-0.6-4.7-0.6c4.7-7,6.7-15.8,5-18c-4.6-5.9-12.6-3.1-12.7-3l0,0 c-0.9-0.2-1.9-0.3-3-0.3c-2,0-3.5,0.5-4.7,1.4c0,0-14.3-5.9-13.6,7.4c0.1,2.8,4,21.3,8.7,15.7c1.7-2,3.3-3.8,3.3-3.8 c0.8,0.5,1.8,0.8,2.8,0.7l0.1-0.1c0,0.3,0,0.5,0,0.8c-1.2,1.3-0.8,1.6-3.2,2.1c-2.4,0.5-1,1.4-0.1,1.6c1.1,0.3,3.7,0.7,5.5-1.8 l-0.1,0.3c0.5,0.4,0.8,2.4,0.7,4.3c-0.1,1.9-0.1,3.2,0.3,4.2c0.4,1,0.7,3.3,3.9,2.6c2.6-0.6,4-2,4.2-4.5c0.1-1.7,0.4-1.5,0.5-3 l0.2-0.7c0.3-2.3,0-3.1,1.7-2.8l0.4,0c1.2,0.1,2.8-0.2,3.7-0.6C39,26.4,40.2,24.9,38.3,25.3L38.3,25.3z'/%3E%3Cpath class='st2' d='M21.8,26.6c-0.1,4.4,0,8.8,0.5,9.8c0.4,1.1,1.3,3.2,4.5,2.5c2.6-0.6,3.6-1.7,4-4.1c0.3-1.8,0.9-6.7,1-7.7'/%3E%3Cpath class='st2' d='M18,4.7c0,0-14.3-5.8-13.6,7.4c0.1,2.8,4,21.3,8.7,15.7c1.7-2,3.2-3.7,3.2-3.7'/%3E%3Cpath class='st2' d='M25.7,3.6c-0.5,0.2,7.9-3.1,12.7,3c1.7,2.2-0.3,11-5,18'/%3E%3Cpath class='st3' d='M33.5,24.6c0,0,0.3,1.5,4.7,0.6c1.9-0.4,0.8,1.1-1.2,2c-1.6,0.8-5.3,0.9-5.3-0.1 C31.6,24.5,33.6,25.3,33.5,24.6c-0.1-0.6-1.1-1.2-1.7-2.7c-0.5-1.3-7.3-11.2,1.9-9.7c0.3-0.1-2.4-8.7-11-8.9 c-8.6-0.1-8.3,10.6-8.3,10.6'/%3E%3Cpath class='st2' d='M19.4,25.6c-1.2,1.3-0.8,1.6-3.2,2.1c-2.4,0.5-1,1.4-0.1,1.6c1.1,0.3,3.7,0.7,5.5-1.8c0.5-0.8,0-2-0.7-2.3 C20.5,25.1,20,24.9,19.4,25.6L19.4,25.6z'/%3E%3Cpath class='st2' d='M19.3,25.5c-0.1-0.8,0.3-1.7,0.7-2.8c0.6-1.6,2-3.3,0.9-8.5c-0.8-3.9-6.5-0.8-6.5-0.3c0,0.5,0.3,2.7-0.1,5.2 c-0.5,3.3,2.1,6,5,5.7'/%3E%3Cpath class='st4' d='M18,13.8c0,0.2,0.3,0.7,0.8,0.7c0.5,0.1,0.9-0.3,0.9-0.5c0-0.2-0.3-0.4-0.8-0.4C18.4,13.6,18,13.7,18,13.8 L18,13.8z'/%3E%3Cpath class='st5' d='M32,13.5c0,0.2-0.3,0.7-0.8,0.7c-0.5,0.1-0.9-0.3-0.9-0.5c0-0.2,0.3-0.4,0.8-0.4C31.6,13.2,32,13.3,32,13.5 L32,13.5z'/%3E%3Cpath class='st2' d='M33.7,12.2c0.1,1.4-0.3,2.4-0.4,3.9c-0.1,2.2,1,4.7-0.6,7.2'/%3E%3Cpath class='st6' d='M2.7,6.6'/%3E%3C/g%3E%3C/svg%3E%0A") 0 0 no-repeat;
  background-size: 50px 50px;
}

.panel-link-heading {
  text-decoration: none;
  color: inherit;
}

.panel-link-heading:hover {
  text-decoration: none;
  color: inherit;
}

.nav .open > a, .nav .open > a:hover, .nav .open > a:focus {
  background-color: initial !important;
}

#navbar-user {
  font-size: 0.9em;
}


.alert-box {
  padding: 15px; }

.alert-icon {
  display: table-cell; }

.alert-text {
  display: table-cell;
  padding-left: 10px; }

.color-chip {
  align-items: center;
  border-radius: 3px;
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.15);
  color: rgba(0, 0, 0, 0.65);
  display: flex;
  font-size: 1.25em;
  height: 70px;
  justify-content: center;
  margin: 0 0 0.5em;
  width: 100%; }

.bg-highlight {
  background-color: $color-primary-light; }

.bg-border {
  background-color: $color-primary-light; }

.opacity-5 {
  opacity: 0.5;  }

.pg-docker {
  position:absolute;
  left:0px;
  right:0px;
  bottom:0px;
  top: $navbar-height !important;
}

.pg-docker-native {
  top: 0px !important;
  border-top: 1px solid $border-color;
}

.pg-panel-content {
  position:absolute;
  top:0px;
  left:0px;
  right:0px;
  bottom:0px;
  height: 100%!important;
}

.pg-prop-footer {
  position: absolute;
  left: 0px;
  right: 0px;
  bottom : 0px;
  z-index: 4;

  & .pg-prop-btn-group {
    min-width: 100%;
    left: 0px;
    right: 0px;

    &.pg-prop-btn-group-below {
      text-align: right;
      padding: $footer-padding;
      background: $header-bg;
      border-top: $panel-border;
    }
  }
}



.pg-prop-btn-group .dropdown-menu {
  min-width: initial;
}

.pg-prop-content {
    position: absolute;
    overflow: auto;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
}

/* A generic class to make the overflow hidden of a DOM element */
.pg-no-overflow {
    overflow: hidden;
}


.pg-prop-has-btn-group-below {
    margin-bottom: 33px;
}

.pg-prop-btn-group-above {
  border-bottom: $panel-border;
}

.has-pg-prop-btn-group {
    top: 45px;
    height: calc(100% - 45px);
}

.pg-prop-content > div {
    margin-top: 5px;
    margin-bottom: 5px;
}

.pg-prop-content .uneditable-input {
    white-space: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overow: ellipsis;
    height: auto !important;
}

.obj_properties {
    padding: 0px;
    height: 100%;
    width: 100%;
    background-color: $color-gray-light;
}

/* Message panel shown on browser tabs */
.pg-panel-message {
    width: 80%;
    margin: 0 auto;
    padding-top: 25px !important;
    position: relative;
    text-align: center;
    font-size: $font-size-base;

    &:before {
        font-family: $font-family-icon;
        content: "\f05a" !important;
        font-size: 1rem;
        margin-right: 0.5rem;
        font-weight: 900;
    }

    &.pg-panel-error:before {
        content: "\f06a" !important;
        font-weight: 900;
    }
}

.pgadmin-control {
    padding: 0px 15px 5px 15px;
    margin-bottom: 0px;
    display: inline-block;
    height: 30px;
}


.pgadmin-control-group {
  margin: 0rem 0rem $form-group-margin-bottom 0rem;
  padding: 0rem;
  min-width: 34px;

  &.sql, &.sqltab {
    margin: 0px;
    padding: 0px;
    height: 100%;
  }
}

fieldset.inline-fieldset {
    padding: 10px;
    border-radius: $card-border-radius;
    background: $color-gray-light;
    border: $panel-border;
    & legend {
      font-size: 0.875rem;
      font-weight: bold;
    }
}

fieldset.inline-fieldset-without-border {
    margin: 0px; margin-left: 0px; margin-right: 0px;
    padding-right: 0px; padding-left: 0px; padding-top: 0px; padding-bottom: 0px;
    border: 0px solid; border-radius: 0px;
}

fieldset.inline-fieldset > legend {
    display: block; border: 0px solid $color-fg; box-shadow: none;
    box-sizing: content-box; top: auto; bottom: auto; left: auto;
    font-size: 14px; font-style: normal; font-weight: 600;
    height: 20px; line-height: 20px; margin: 0px; padding-bottom: 0px;
    padding-left: 5px; padding-right: 5px; padding-top: 0px;
    vertical-align: middle; width: auto;
}

fieldset.inline-fieldset-without-border legend {
    border: none; margin-bottom: 0px !important;
 }

fieldset.inline-fieldset > div {
    padding: 0px; margin: 0px; border: 0px;
}

/* Override CSS for Colour Picker to match it with pgAdmin4 style */
.sp-replacer {
  background: $color-bg;
  border: solid 1px $color-gray-light;
  border-radius: 3px;
}

.sp-replacer:hover {
  border-color: $color-gray-light;
}

.sp-replacer.sp-active {
  border-color: $color-primary-light;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

.sp-replacer.sp-disabled {
    background-color: $color-gray-lighter;
}

.sp-container {
  background-color: $color-bg;
  border: solid 1px $color-gray-light;
  border-radius: 3px !important;
}

.sp-palette-button-container button,
.sp-palette-button-container button:hover {
  padding: 5px;
  background-color: $color-primary;
  background-image: none;
  font-family: $font-family-primary;
  font-size: 0.75rem;
  color: $color-primary-fg;
  text-shadow: none;
  -webkit-font-smoothing: auto;
}

.sp-container button:active {
    border: 1px solid $color-primary;
    border-bottom: none;
    -webkit-box-shadow: inset 0 0 5px 2px $color-primary, 0 1px 0 0 $color-primary-light;
    -moz-box-shadow: inset 0 0 5px 2px $color-primary, 0 1px 0 0 $color-primary-light;
    -ms-box-shadow: inset 0 0 5px 2px $color-primary, 0 1px 0 0 $color-primary-light;
    -o-box-shadow: inset 0 0 5px 2px $color-primary, 0 1px 0 0 $color-primary-light;
    box-shadow: inset 0 0 5px 2px $color-primary, 0 1px 0 0 $color-primary-light;
}

.sp-dd {
  font-size: 8px;
  color:  $color-gray;
}

.pgadmin-control-error-message{
  padding: 15px;
}

.tab-pane.sql-code-control {
  & .pgadmin-control-group{
    margin: 0px;
    padding: 0px;
    height: 100%;
  }
}

.dashboard-tab-container,
.pg-panel-statistics-container,
.pg-panel-dependencies-container,
.pg-panel-dependents-container,
.pg-prop-coll-container {
    width: 100%;
    overflow: auto;
    border-radius: $card-border-radius;
    border: $panel-border;
}

.pg-prop-header {
    position: relative;
    left: 0px;
    right: 0px;
    top : 0px;
    background-color: $color-bg;
}

/* Overrides/fixes for pgAdmin specific styling */

.highlight {
    padding: 5px;
    margin-bottom: 5px;
    background-color: $color-gray-lighter;
    border: 1px solid $color-gray-lighter;
    border-radius: 3px;
}

.icon-fa::before {
    font: normal normal normal 14px/1 $font-family-icon;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transform: translate(0, 0);
    display: inline-block;
    margin-left: -18px;
    margin-right: 9px;
}

.width_percent_3 { width: 3%; }
.width_percent_5 { width: 5%; }
.width_percent_10 { width: 10%; }
.width_percent_15 { width: 15%; }
.width_percent_20 { width: 20%; }
.width_percent_25 { width: 25%; }
.width_percent_30 { width: 30%; }
.width_percent_35 { width: 35%; }
.width_percent_40 { width: 40%; }
.width_percent_45 { width: 45%; }
.width_percent_50 { width: 50%; }
.width_percent_55 { width: 55%; }
.width_percent_60 { width: 60%; }
.width_percent_65 { width: 65%; }
.width_percent_70 { width: 70%; }
.width_percent_75 { width: 75%; }
.width_percent_80 { width: 80%; }
.width_percent_85 { width: 85%; }
.width_percent_90 { width: 90%; }
.width_percent_95 { width: 95%; }
.width_percent_99 { width: 99%; }
.width_percent_100 { width: 100%; }

.navtab-inline-controls {

  height: $title-height;
  display: flex;
  text-align: right !important;
  border-bottom: $panel-border;

  & .input-group-text,
  & .form-control,
  & .btn {
    border: none;
    border-radius: 0px;
    border-left: $panel-border;
    height: 100%;
  }

  & .btn-secondary:focus {
    box-shadow: $input-btn-focus-box-shadow;
  }

  & .input-group {
    & .input-group-text {
      background: $input-bg;
    }
    & .form-control {
      border-left: none !important;
    }
  }
}

.negative-space {
  min-height: 100%;
  min-width: 100%;
  background: $negative-bg;
  overflow: auto;
}

/* This rule will stop Chrome apply highlighting to elements such as DIV's used as modals */
*:focus {
  outline: none;
}

input[type="checkbox"],
select,
a {
    &:focus {
      &.navbar-brand, &.dropdown-item {
          outline: none !important;
      }
      outline: 2px solid $input-focus-border-color !important;
    }
}

div.rolmembership {
    margin-top: 15px;
}


.inline-tab-panel > ul.nav-tabs > li:first-child > a,
.inline-tab-panel > ul.nav-tabs > li:first-child > a:active,
.inline-tab-panel > ul.nav-tabs > li:first-child > a:hover,
.inline-tab-panel > ul.nav-tabs > li:first-child > a:focus {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.inline-tab-panel > ul.tab-content {
  padding-left: 5px; padding-right: 5px; border-color: $color-gray-lighter;
  border-width: 0px 1px 1px 1px; border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px; border-style: solid solid;
}

.inline-tab-panel  {
  float: left; width: 100%;
  background-color: $header-bg;
  border: 1px solid $border-color;
  border-radius: $card-border-radius;
  & > .tab-content {
    padding: 0px;
    margin: 0px;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  &.inline-tab-panel-padded > .tab-content {
    padding: 0.5rem;
  }
}

.inline-tab-panel > ul.tab-content > div.tab-pane {
  min-height: 150px; padding: 0px !important;
}

.inline-tab-panel > ul.tab-content > div.tab-pane > *:first-child {
  margin-top: 5px;
}

.inline-tab-panel > ul.tab-content > div.tab-pane > *:last-child {
  margin-bottom: 5px;
}

.inline-tab-panel > .tab-content > div.tab-pane {
  padding: 0px;
  & > .pgadmin-control-group {
    & > div.subnode {
      border: none !important;
      border-bottom: $panel-border;
    }
  }
}

table tr th {
  & button {
    background: none;
    border: none;
    color: $color-fg;
    padding: 0;
  }
  & button:focus {
    outline: $input-focus-border-color auto 5px !important;
  }
}

table tr td {
  td.edit-cell:focus,
  td.delete-cell:focus,
  td.string-cell:focus {
    outline: $input-focus-border-color auto 5px !important;
  }
}

/* Specific to IE11 where we want to highlight the focus on grid buttons */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  table tr td {
    td.edit-cell:focus,
    td.delete-cell:focus,
    td.string-cell:focus {
      border: 2px solid $input-focus-border-color !important;
    }
  }
}

.privilege-checkbox{
    & .custom-control-label {
        font-size: 0.7rem;
        line-height: 1.7;
        &:before, &:after {
            height: 0.8rem;
            width: 0.8rem;
        }
    }
}

span.button-label {
  font-family: $font-family-primary;
  font-size: initial;
}

form[name="change_password_form"] .help-block {
    color: $color-danger !important;
}

/* animate blink */
.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;

}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

.close-error {
  cursor: pointer;
}

.help-block {
  white-space: normal;
}

/* Disable text selection where not wanted */
body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 0.875rem;
  height: 100vh;
  overflow: hidden;
  margin: 0;
  font-family: $font-family-primary;
}

/* iFrames should have no border */
iframe {
	border-width: 0;
}

/* Security label's label column font size */
.override_label_class_font_size {
  font-size: inherit !important;
}

.multi-checkbox .check.checked,
.multi-checkbox .check.unchecked {
  background: $color-bg;
}

.multi-checkbox .check.partial {
  background: $color-gray-lighter;
}

.multi-checkbox .check.checked:after {
  content: "\2713";
  font-weight: 900;
}

.multi-checkbox .check.partial:after {
  content: "\003F";
  font-weight: 900;
}

.nav-tabs {
  background-color: $header-bg;
}

.editor-toolbar {
  background: $editor-toolbar-bg;
  padding: 0.05rem 0.25rem;
}


table.table-noouter-border {
  border: none !important;

  & > tbody > tr:last-of-type{
    &  > td {
      border-bottom: $table-border-width solid transparent;
    }
  }

  &.table-noheader {
    & > tbody tr:first-of-type td {
      border-top: none !important;
    }
  }
}

table.table-bottom-border {
  tbody tr:last-of-type{
    & td, & th {
      border-bottom: $panel-border;
    }
  }
}

table.table-right-border {
  tr {
    & td:last-of-type, & th:last-of-type {
      border-right: $panel-border;
    }
  }
}

table.table-empty-rows{
  thead th:last-of-type,tr:last-of-type{
    & td, & th {
      border-bottom: $panel-border;
    }
  }
}


.context-menu-list .context-menu-submenu:after {
  font-family: $font-family-icon;
  content: "\f054" !important;
  right: 15px;
  top: 3px;
  font-size: 0.6rem;
  line-height: 2;
  border-style: none;
  font-weight: 900;
}

.login_page {
  background-color: $login-page-background;
  height: 100%;
  position:relative;
  z-index:1;
  color: $security-text-color;

  & a {
    color: $security-text-color;
  }

  & .panel-container {
    background-color: rgba($security-btn-color, 0.25);
    padding: 0px;
  }

  & .panel-header {
    padding-bottom: 1.0rem;
  }
  & .panel-body {
    padding-bottom: 0.8rem;
  }
  & .btn-login  {
    background-color: $security-btn-color;
  }
  & .btn-validate {
    background-color: $security-btn-color;
  }
  & .btn-oauth {
    background-color: $security-btn-color;
  }
  & .user-language {
    & select{
      background-color: $color-primary;
      color: $security-text-color;

      & option{
        background-color: $color-primary;
        color: $security-text-color;
      }
    }
  }
  & .pg-icon {
    width: 28px;
    height: 28px;
    background-size: 28px 28px;
  }
}

.login_banner {
    position: fixed;
    width: 80%;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 100;
}

.auth_page {
  background-color: $color-gray-light;

  & .panel-container {
    background-color: rgba($color-gray-dark, 0.75);
    border-radius: $border-radius * 2;
  }
}

.change_pass {
  height: 100%;
  position:relative;
  z-index:1;

  & .panel-header {
    padding-bottom: 1.0rem;
  }
  & .panel-body {
    padding-bottom: 0.8rem;
  }

  & .btn-change-pass {
    background-color: $security-btn-color;
  }

  & .pg-icon-blue {
    display: inline-block;
    width: 28px;
    height: 28px;
    /*
     * Using the SVG postgresql logo, modified to set the background color as
     * black
     * https://wiki.postgresql.org/images/a/a4/PostgreSQL_logo.3colors.svg
     */
    background: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 42 42' style='enable-background:new 0 0 42 42;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bstroke:%23000000;stroke-width:3.3022;%7D .st1%7Bfill:%23336791;%7D .st2%7Bfill:none;stroke:%23FFFFFF;stroke-width:1.1007;stroke-linecap:round;stroke-linejoin:round;%7D .st3%7Bfill:none;stroke:%23FFFFFF;stroke-width:1.1007;stroke-linecap:round;stroke-linejoin:bevel;%7D .st4%7Bfill:%23FFFFFF;stroke:%23FFFFFF;stroke-width:0.3669;%7D .st5%7Bfill:%23FFFFFF;stroke:%23FFFFFF;stroke-width:0.1835;%7D .st6%7Bfill:none;stroke:%23FFFFFF;stroke-width:0.2649;stroke-linecap:round;stroke-linejoin:round;%7D%0A%3C/style%3E%3Cg id='orginal'%3E%3C/g%3E%3Cg id='Layer_x0020_3'%3E%3Cpath class='st0' d='M31.3,30c0.3-2.1,0.2-2.4,1.7-2.1l0.4,0c1.2,0.1,2.8-0.2,3.7-0.6c2-0.9,3.1-2.4,1.2-2 c-4.4,0.9-4.7-0.6-4.7-0.6c4.7-7,6.7-15.8,5-18c-4.6-5.9-12.6-3.1-12.7-3l0,0c-0.9-0.2-1.9-0.3-3-0.3c-2,0-3.5,0.5-4.7,1.4 c0,0-14.3-5.9-13.6,7.4c0.1,2.8,4,21.3,8.7,15.7c1.7-2,3.3-3.8,3.3-3.8c0.8,0.5,1.8,0.8,2.8,0.7l0.1-0.1c0,0.3,0,0.5,0,0.8 c-1.2,1.3-0.8,1.6-3.2,2.1c-2.4,0.5-1,1.4-0.1,1.6c1.1,0.3,3.7,0.7,5.5-1.8l-0.1,0.3c0.5,0.4,0.4,2.7,0.5,4.4 c0.1,1.7,0.2,3.2,0.5,4.1c0.3,0.9,0.7,3.3,3.9,2.6C29.1,38.3,31.1,37.5,31.3,30'/%3E%3Cpath class='st1' d='M38.3,25.3c-4.4,0.9-4.7-0.6-4.7-0.6c4.7-7,6.7-15.8,5-18c-4.6-5.9-12.6-3.1-12.7-3l0,0 c-0.9-0.2-1.9-0.3-3-0.3c-2,0-3.5,0.5-4.7,1.4c0,0-14.3-5.9-13.6,7.4c0.1,2.8,4,21.3,8.7,15.7c1.7-2,3.3-3.8,3.3-3.8 c0.8,0.5,1.8,0.8,2.8,0.7l0.1-0.1c0,0.3,0,0.5,0,0.8c-1.2,1.3-0.8,1.6-3.2,2.1c-2.4,0.5-1,1.4-0.1,1.6c1.1,0.3,3.7,0.7,5.5-1.8 l-0.1,0.3c0.5,0.4,0.8,2.4,0.7,4.3c-0.1,1.9-0.1,3.2,0.3,4.2c0.4,1,0.7,3.3,3.9,2.6c2.6-0.6,4-2,4.2-4.5c0.1-1.7,0.4-1.5,0.5-3 l0.2-0.7c0.3-2.3,0-3.1,1.7-2.8l0.4,0c1.2,0.1,2.8-0.2,3.7-0.6C39,26.4,40.2,24.9,38.3,25.3L38.3,25.3z'/%3E%3Cpath class='st2' d='M21.8,26.6c-0.1,4.4,0,8.8,0.5,9.8c0.4,1.1,1.3,3.2,4.5,2.5c2.6-0.6,3.6-1.7,4-4.1c0.3-1.8,0.9-6.7,1-7.7'/%3E%3Cpath class='st2' d='M18,4.7c0,0-14.3-5.8-13.6,7.4c0.1,2.8,4,21.3,8.7,15.7c1.7-2,3.2-3.7,3.2-3.7'/%3E%3Cpath class='st2' d='M25.7,3.6c-0.5,0.2,7.9-3.1,12.7,3c1.7,2.2-0.3,11-5,18'/%3E%3Cpath class='st3' d='M33.5,24.6c0,0,0.3,1.5,4.7,0.6c1.9-0.4,0.8,1.1-1.2,2c-1.6,0.8-5.3,0.9-5.3-0.1 C31.6,24.5,33.6,25.3,33.5,24.6c-0.1-0.6-1.1-1.2-1.7-2.7c-0.5-1.3-7.3-11.2,1.9-9.7c0.3-0.1-2.4-8.7-11-8.9 c-8.6-0.1-8.3,10.6-8.3,10.6'/%3E%3Cpath class='st2' d='M19.4,25.6c-1.2,1.3-0.8,1.6-3.2,2.1c-2.4,0.5-1,1.4-0.1,1.6c1.1,0.3,3.7,0.7,5.5-1.8c0.5-0.8,0-2-0.7-2.3 C20.5,25.1,20,24.9,19.4,25.6L19.4,25.6z'/%3E%3Cpath class='st2' d='M19.3,25.5c-0.1-0.8,0.3-1.7,0.7-2.8c0.6-1.6,2-3.3,0.9-8.5c-0.8-3.9-6.5-0.8-6.5-0.3c0,0.5,0.3,2.7-0.1,5.2 c-0.5,3.3,2.1,6,5,5.7'/%3E%3Cpath class='st4' d='M18,13.8c0,0.2,0.3,0.7,0.8,0.7c0.5,0.1,0.9-0.3,0.9-0.5c0-0.2-0.3-0.4-0.8-0.4C18.4,13.6,18,13.7,18,13.8 L18,13.8z'/%3E%3Cpath class='st5' d='M32,13.5c0,0.2-0.3,0.7-0.8,0.7c-0.5,0.1-0.9-0.3-0.9-0.5c0-0.2,0.3-0.4,0.8-0.4C31.6,13.2,32,13.3,32,13.5 L32,13.5z'/%3E%3Cpath class='st2' d='M33.7,12.2c0.1,1.4-0.3,2.4-0.4,3.9c-0.1,2.2,1,4.7-0.6,7.2'/%3E%3Cpath class='st6' d='M2.7,6.6'/%3E%3C/g%3E%3C/svg%3E%0A") 0 0 no-repeat;
    background-size: 28px 28px;
  }
}

.ajs-content {
  .tab-content {
    bottom: 0;

  }
}

.filter-textarea {
    height: 100%;
    & .CodeMirror-scroll {
      min-height: 120px;
      max-height: 120px;
    }
}

.dataview_filter_dialog {
  left: 0 !important;
  right: 0 !important;
  padding: 0px !important;
  position: absolute;
}

.drag-tree-node {
  position: absolute;
  top:-100px;
  left:0;
  z-index: 99999;
  color: $input-focus-color;
  background: $input-bg;
  border: $input-border-width solid $input-focus-border-color;
  border-radius: $input-border-radius;
  padding: $input-btn-padding-y $input-btn-padding-x;
}

::placeholder {
  color: $input-placeholder-color;
}

.pg-font-icon {
  &:before {
    vertical-align: middle;
  }
}

.dialog-node-icon {
  margin-right: 2px !important;
  padding: 0px 10px;
  background-position: 50%;
}

textarea {
    color: $input-color;
    background-color: $input-bg;
}

/* Webkit customizations */

::-webkit-scrollbar, ::-webkit-scrollbar-corner {
    width: $scrollbar-width !important;
    height: $scrollbar-width !important;
    background-color: rgba($scrollbar-base-color, 0.2);
}

::-webkit-scrollbar-thumb {
    border: 0.25rem solid transparent;
    border-radius: $border-radius*2;
    background: rgba($scrollbar-base-color, 0.7) !important;
    background-clip: content-box !important;
}

::-webkit-scrollbar-thumb:hover {
    border: 0.25rem solid transparent;
    background-color: $scrollbar-base-color !important;
    background-clip: content-box !important;
}


input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: $color-primary-light-fg;
  -webkit-box-shadow: 0 0 0px 1000px $color-primary-light inset;
  transition: background-color 5000s ease-in-out 0s;
}

/* Left side has a check icon, right side corrected */
.btn-radiomodern {
    padding-right: 1.75*$input-btn-padding-x !important;
    &.disabled {
      pointer-events: none !important;
    }
}

.fa {
  font-weight: 600 !important;
}

.pull-left{
  float:left
}

.menu-groups-a:hover span{
  color: $white !important;
}

#myDropdown a:hover {background-color: $dropdown-link-hover-bg; color:$white !important;}

.text-wrap {
  word-break: break-word;
}

.sql_textarea {
  height: 100%;
}

.visibility-hidden {
  visibility: hidden;
}

ul {
  margin-left: 0;
  padding: 0;
  cursor: default;
}

li {
  padding: 0 0 0 0px;
  list-style: none;
  margin: 0;
}
